import { useEffect } from 'react';
import { useParams } from 'react-router';
import AlmacenForm from '../../components/almacenes/AlmacenForm';
import { useAlmacenesStore, type ActualizarAlmacen } from '../../stores/almacenes/almacenes.store';

const EditarAlmacen = () => {
  const id = useParams<{ id: string }>().id ?? '';
  const {
    current: almacen,
    actualizar,
    activar,
    desactivar,
    cargarPorId
  } = useAlmacenesStore((state) => state);

  useEffect(() => {
    if (!id) return;

    cargarPorId(id);
  }, [id]);

  const handleSave = async (values: ActualizarAlmacen) => {
    await actualizar(id, values);
  };

  const handleDelete = async () => {
    await desactivar(id);
  };

  const handleActivate = async () => {
    await activar(id);
  };

  return (
    <AlmacenForm
      almacen={almacen}
      onSave={handleSave}
      onDelete={handleDelete}
      onActivate={handleActivate}
    />
  );
};

export default EditarAlmacen;
